import React from 'react';
import {
  chakra,
  ChakraComponent,
  useColorModeValue,
} from '@cardboard-ui/react';

interface NotificationBubbleProps {
  hasUnread?: boolean;
  showWhenUnread?: boolean;
}

export const NotificationBubble: ChakraComponent<
  'span',
  NotificationBubbleProps
> = (props: NotificationBubbleProps) => {
  const { hasUnread, showWhenUnread, ...spanProps } = props;
  const size = hasUnread || showWhenUnread ? 2 : 0;
  const grayColor = useColorModeValue('gray.200', 'gray.600');
  return (
    <chakra.span
      borderRadius="full"
      bgColor={hasUnread ? 'red.500' : grayColor}
      w={size}
      h={size}
      {...spanProps}
    />
  );
};
